export default {
  'buildHash': 1712233195133
};
